/**
 * An enum representing the role of the user in zenity
 */
export enum ZenityUserRoleEnum {
  viewer = 'viewer',
  operator = 'operator',
  analyst = 'analyst',
  admin = 'admin',
}

export interface AccountManagementUserModel {
  userId: string;
  email: string;
  name: string;
  createdAt: Date;
  lastLogin: Date | null;
  role?: ZenityUserRoleEnum;
  pictureUrl: URL;
}

export interface UserToAddModel {
  email: string;
  role: ZenityUserRoleEnum;
  authentication_id: string;
}

export interface ModifyUserRoleModel {
  userId: string;
  newRole: ZenityUserRoleEnum;
}

export interface AccountManagementClientApiModel {
  clientId: string;
  clientSecret: string;
}

export interface AccountManagementAuthenticationModel {
  id: string;
  name: string;
  strategy?: string;
}

export interface AccountManagementInvitationModel {
  id: string;
  email: string;
  name: string;
  createdAt: Date;
  expiresAt: Date;
  role: ZenityUserRoleEnum;
  invitationUrl: string;
}

export enum UsersSupportedActions {
  Delete = 'delete',
  Copy = 'copy',
}

export enum AccountCategory {
  paid = 'paid',
  zenity = 'zenity',
  internal = 'internal',
  poc = 'POC', // limited access to the platform
  inactive = 'inactive', // when user tested "POC" and then canceled the subscription. Handled on BE side
}

export interface AccountCategoryResponse {
  id: string;
  category: AccountCategory;
}
